import { createAsyncThunk } from '@reduxjs/toolkit';

import { OverviewService } from 'api';

import { StatementData } from 'models';

export const getUserProfit = createAsyncThunk('user/profit', async (payload: StatementData) => {
	return await OverviewService.getProfit(payload);
});
